export const ADD_PAGE = 'add_page'
export const ORDER_PAGES = 'order_pages'
export const FETCH_PAGES = 'fetch_pages'
export const REMOVE_PAGE = 'remove_page'
export const UPDATE_PAGE = 'update_page'
export const SET_PAGES = 'set_pages'
export const SET_SELECTED_PAGE = 'set_selected_page'
export const BATCH_UPDATE_PAGES = 'batch_update_pages'



// WEBPACK FOOTER //
// ./src/store/types/pages.js